import {FileUpload2} from './FileUpload2.js'
export default function Test2(){
    return(
        <div>
            <div>
                <FileUpload2 />
            </div>
        </div>
    )
}